import { render, staticRenderFns } from "./ActivityStatistics.vue?vue&type=template&id=e2ea4d8e&scoped=true&"
import script from "./ActivityStatistics.vue?vue&type=script&lang=js&"
export * from "./ActivityStatistics.vue?vue&type=script&lang=js&"
import style0 from "./ActivityStatistics.vue?vue&type=style&index=0&id=e2ea4d8e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2ea4d8e",
  null
  
)

export default component.exports